import Editable from './editable.vue'
export default Editable
